import { FooterSEOText } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOText";
import { Footer } from "@faire/retailer-visitor-shared/components/Footer/index";
import { Column, HorizontalLine } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import * as React from "react";
import styled from "styled-components";

export const FooterSEOContent: React.FC = () => {
  return (
    <Footer noTopBorder childFirst>
      <Container>
        <SEOColumn>
          <FooterSEOText />
        </SEOColumn>
        <SEOHorizontalLine />
      </Container>
    </Footer>
  );
};

const Container = styled.section`
  display: flex;
  flex-direction: column;
  padding: 40px 28px 0;

  ${responsiveMediaQueries.tabletAndAbove} {
    padding: 24px 0px;
  }
`;

const SEOColumn = styled(Column).attrs({ align: "flex-start" })``;

const SEOHorizontalLine = styled(HorizontalLine)`
  margin-top: 16px;

  ${responsiveMediaQueries.tabletAndAbove} {
    display: none;
  }
`;
